namespace SorAraBul {
    export enum FormWizardSteps {
        HasoInfoAndContractApproval = 1,
        GeneralInformation = 2,
        InformationRequiredForTheReport = 3
    }
    Serenity.Decorators.registerEnumType(FormWizardSteps, 'SorAraBul.FormWizardSteps');
}
